// filepath: src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import ru from './locales/ru/translation.json';
import pl from './locales/pl/translation.json';

// Browser-Sprache ermitteln
const browserLang = navigator.language || navigator.userLanguage;
// Wenn Russisch (ru-*) → 'ru', Polnisch (pl-*) → 'pl', sonst → 'en'
const initialLang = browserLang.toLowerCase().startsWith('ru') ? 'ru' : 
                   browserLang.toLowerCase().startsWith('pl') ? 'pl' : 'en';

i18n
  .use(initReactI18next)  // bindet i18next an React
  .init({
    // direkt auf die ermittelte Sprache setzen
    lng: initialLang,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru', 'pl'],
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      pl: { translation: pl }
    },
    interpolation: {
      escapeValue: false
    }
  });

// <html lang="..."> immer aktuell halten
i18n.on('languageChanged', lng => {
  document.documentElement.lang = lng;
});

export default i18n;
